module.exports = __webpack_public_path__ + "static/img/img.8e16743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.jpg
// module id = Rx1w
// module chunks = 1